import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@monorepo/nova-ui';
import { ErrorStateProps } from '../types';

export const ErrorState: FunctionComponent<ErrorStateProps> = ({ type }) => {
  const { t } = useTranslation(['login']);

  if (type === 'error') {
    return (
      <Alert
        severity="error"
        message={t('login:traders_login.error', {
          defaultValue: 'Failed to load trading credentials',
        })}
      />
    );
  }

  return (
    <Alert
      severity="warning"
      message={t('login:traders_login.no_credentials', {
        defaultValue: 'No trading credentials found',
      })}
    />
  );
};
